import {
  faCakeCandles,
  faCalendarPlus,
  faHandHoldingDollar,
  faMoneyBillTransfer,
  faPhone,
  faSackDollar,
  faUserPen,
  faVenusMars,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useAgeSegments, useGenders } from "../../hooks/catalogs";
import { useFormatDate } from "../../hooks/date";
import { Card, CardContent, CardHeader } from "../ui/card";
import { CustomerResponse } from "../../rest/defs";

const CustomerCard = ({ item }: { item: CustomerResponse }) => {
  const { mapGender } = useGenders();
  const { mapAgeSegment } = useAgeSegments();
  const formatDate = useFormatDate();

  return (
    <Card className="flex h-full flex-col transition-shadow hover:shadow-medium">
      <CardHeader className="flex-row items-start gap-3 space-y-0 p-4">
        <span className="mt-0.5 text-xs font-bold text-muted-foreground">
          #{item.id}
        </span>
        <Link
          to={`/customer/${item.id}`}
          className="flex items-center gap-2 text-base font-semibold text-primary hover:underline"
        >
          <FontAwesomeIcon icon={faUserPen} className="h-4 w-4 shrink-0" />
          {item.customer_name}
        </Link>
      </CardHeader>

      <CardContent className="flex flex-1 flex-col gap-3 p-4 pt-0 text-sm">
        <div className="space-y-1.5 text-muted-foreground">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faPhone} className="w-4 text-center" />
            <span>{item.phone}</span>
          </div>
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faVenusMars} className="w-4 text-center" />
            <span>{mapGender(item.gender)}</span>
          </div>
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCakeCandles} className="w-4 text-center" />
            <span>{mapAgeSegment(item.age_segment)}</span>
          </div>
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCalendarPlus} className="w-4 text-center" />
            <span>Desde el {formatDate(item.create_dt)}</span>
          </div>
        </div>

        <div className="mt-auto space-y-2 border-t pt-3">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              icon={faSackDollar}
              className="w-4 text-center text-primary"
            />
            <span>
              <strong>${Number(item.value).toFixed(2)}</strong>{" "}
              <Link
                to={`/customer/${item.id}/transactions`}
                className="text-muted-foreground hover:underline"
              >
                ({Number(item.amount).toFixed(2)} puntos)
              </Link>
            </span>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            <Link
              to={`/customer/${item.id}/purchase/new`}
              className="flex items-center gap-2 text-primary hover:underline"
            >
              <FontAwesomeIcon
                icon={faHandHoldingDollar}
                className="w-4 text-center"
              />
              Acumular puntos
            </Link>
            <Link
              to={`/customer/${item.id}/exchange/new`}
              className="flex items-center gap-2 text-primary hover:underline"
            >
              <FontAwesomeIcon
                icon={faMoneyBillTransfer}
                className="w-4 text-center"
              />
              Pagar con puntos
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomerCard;
